import { save as Lt } from "@tauri-apps/plugin-dialog";
import { writeTextFile as Dt, writeFile as Vt } from "@tauri-apps/plugin-fs";
import { open as Ut } from "@tauri-apps/plugin-shell";
import le from "axios";
function Me(t, e, r, n, s, a, i, o, d) {
  switch (arguments.length) {
    case 1:
      return t;
    case 2:
      return e(t);
    case 3:
      return r(e(t));
    case 4:
      return n(r(e(t)));
    case 5:
      return s(n(r(e(t))));
    case 6:
      return a(s(n(r(e(t)))));
    case 7:
      return i(a(s(n(r(e(t))))));
    case 8:
      return o(i(a(s(n(r(e(t)))))));
    case 9:
      return d(o(i(a(s(n(r(e(t))))))));
    default: {
      for (var l = arguments[0], p = 1; p < arguments.length; p++)
        l = arguments[p](l);
      return l;
    }
  }
}
var zt = { _tag: "None" }, Mt = function(t) {
  return { _tag: "Some", value: t };
}, Ft = function(t) {
  return { _tag: "Left", left: t };
}, Wt = function(t) {
  return { _tag: "Right", right: t };
}, Bt = function(t) {
  return t.length > 0;
}, Kt = function(t) {
  return t[0];
}, pt = Object.prototype.hasOwnProperty, Ht = Bt, Xt = Kt, He = Xt, Gt = function(t) {
  return t[t.length - 1];
}, Ae = function(t) {
  return function(e) {
    var r = e.split(t);
    return Ht(r) ? r : [e];
  };
};
const Jt = {
  api: {
    async saveFileWithDialog(t) {
      const e = new Blob([t.data], { type: t.contentType }), r = document.createElement("a"), n = URL.createObjectURL(e);
      return r.href = n, r.download = t.suggestedFilename ?? Me(
        n,
        Ae("/"),
        Gt,
        Ae("#"),
        He,
        Ae("?"),
        He
      ), document.body.appendChild(r), r.click(), setTimeout(() => {
        document.body.removeChild(r), URL.revokeObjectURL(n);
      }, 1e3), { type: "unknown" };
    },
    async openExternalLink(t) {
      return window.open(t.url, "_blank"), { type: "unknown" };
    },
    async listen(t, e) {
      const r = (n) => {
        const s = window.location.hash;
        if (s && s.startsWith(`#${t}:`)) {
          const a = s.slice(t.length + 2);
          e({
            event: t,
            id: Date.now(),
            payload: JSON.parse(a)
          });
        }
      };
      return window.addEventListener("hashchange", r), () => window.removeEventListener("hashchange", r);
    },
    async once(t, e) {
      const r = (n) => {
        const s = window.location.hash;
        if (s && s.startsWith(`#${t}:`)) {
          const a = s.slice(t.length + 2);
          window.removeEventListener("hashchange", r), e({
            event: t,
            id: Date.now(),
            payload: JSON.parse(a)
          });
        }
      };
      return window.addEventListener("hashchange", r), () => window.removeEventListener("hashchange", r);
    },
    async emit(t, e) {
      window.location.hash = `${t}:${JSON.stringify(e)}`;
    }
  }
}, Yt = {
  v1: Jt
};
function Qt(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !n : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(t) : n ? n.value : e.get(t);
}
function qt(t, e, r, n, s) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var fe;
function er(t, e = !1) {
  return window.__TAURI_INTERNALS__.transformCallback(t, e);
}
async function b(t, e = {}, r) {
  return window.__TAURI_INTERNALS__.invoke(t, e, r);
}
class tr {
  get rid() {
    return Qt(this, fe, "f");
  }
  constructor(e) {
    fe.set(this, void 0), qt(this, fe, e);
  }
  /**
   * Destroys and cleans up this resource from memory.
   * **You should not call any method on this object anymore and should drop any reference to it.**
   */
  async close() {
    return b("plugin:resources|close", {
      rid: this.rid
    });
  }
}
fe = /* @__PURE__ */ new WeakMap();
var Xe;
(function(t) {
  t.WINDOW_RESIZED = "tauri://resize", t.WINDOW_MOVED = "tauri://move", t.WINDOW_CLOSE_REQUESTED = "tauri://close-requested", t.WINDOW_DESTROYED = "tauri://destroyed", t.WINDOW_FOCUS = "tauri://focus", t.WINDOW_BLUR = "tauri://blur", t.WINDOW_SCALE_FACTOR_CHANGED = "tauri://scale-change", t.WINDOW_THEME_CHANGED = "tauri://theme-changed", t.WINDOW_CREATED = "tauri://window-created", t.WEBVIEW_CREATED = "tauri://webview-created", t.DRAG_ENTER = "tauri://drag-enter", t.DRAG_OVER = "tauri://drag-over", t.DRAG_DROP = "tauri://drag-drop", t.DRAG_LEAVE = "tauri://drag-leave";
})(Xe || (Xe = {}));
async function rr(t, e) {
  await b("plugin:event|unlisten", {
    event: t,
    eventId: e
  });
}
async function me(t, e, r) {
  var n;
  const s = (n = void 0) !== null && n !== void 0 ? n : { kind: "Any" };
  return b("plugin:event|listen", {
    event: t,
    target: s,
    handler: er(e)
  }).then((a) => async () => rr(t, a));
}
async function nr(t, e) {
  await b("plugin:event|emit", {
    event: t,
    payload: e
  });
}
const sr = {
  api: {
    async saveFileWithDialog(t) {
      const e = await Lt({
        filters: t.filters,
        defaultPath: t.suggestedFilename
      });
      return e ? (typeof t.data == "string" ? await Dt(e, t.data) : await Vt(e, t.data), { type: "saved", path: e }) : { type: "cancelled" };
    },
    async openExternalLink(t) {
      return await Ut(t.url), { type: "opened" };
    },
    async listen(t, e) {
      return await me(t, e);
    },
    async once(t, e) {
      const r = await me(t, (n) => {
        r(), e(n);
      });
      return r;
    },
    async emit(t, e) {
      await nr(t, e);
    }
  }
}, ar = {
  v1: sr
};
var w = Ft, T = Wt, ir = zt, or = Mt, cr = function(t) {
  return t._tag === "None";
}, dr = function(t) {
  return function(e) {
    return cr(e) ? t() : e.value;
  };
}, ur = dr, yt = /* @__PURE__ */ ((t) => (t.TEXT_PLAIN = "text/plain", t.TEXT_HTML = "text/html", t.TEXT_CSS = "text/css", t.TEXT_CSV = "text/csv", t.APPLICATION_JSON = "application/json", t.APPLICATION_LD_JSON = "application/ld+json", t.APPLICATION_XML = "application/xml", t.TEXT_XML = "text/xml", t.APPLICATION_FORM = "application/x-www-form-urlencoded", t.APPLICATION_OCTET = "application/octet-stream", t.MULTIPART_FORM = "multipart/form-data", t))(yt || {});
const gt = {
  body: (t, e) => ({
    body: new Uint8Array(t),
    mediaType: typeof e == "string" ? Object.values(yt).find((r) => e.includes(r)) ?? "application/octet-stream" : e ?? "application/octet-stream"
    /* APPLICATION_OCTET */
  })
}, V = {
  text: (t) => t,
  json: (t) => t,
  xml: (t) => t,
  form: (t) => t,
  binary: (t) => t,
  multipart: (t) => t,
  stream: (t) => t,
  urlencoded: (t) => Me(
    t,
    (e) => typeof e == "string" ? or(e) : ir,
    ur(() => {
      const e = new URLSearchParams();
      return Object.entries(t).filter(([n, s]) => s != null).forEach(
        ([n, s]) => e.append(n, s.toString())
      ), e.toString();
    })
  )
}, H = {
  /**
   * Creates text content. Useful for:
   * - Plain text
   * - Pre-stringified JSON (to avoid encoding escapes)
   * - Custom text formats
   */
  text: (t, e) => ({
    kind: "text",
    content: V.text(t),
    mediaType: e ?? "text/plain"
    /* TEXT_PLAIN */
  }),
  /**
   * Creates JSON content with automatic serialization.
   * Note: If you already have a JSON string, consider using `text()`
   * with `APPLICATION_JSON` mediaType to avoid double-encoding.
   */
  json: (t, e) => ({
    kind: "json",
    content: V.json(t),
    mediaType: e ?? "application/json"
    /* APPLICATION_JSON */
  }),
  /**
   * Creates XML content. Currently processed as text.
   */
  xml: (t, e) => ({
    kind: "xml",
    content: V.xml(t),
    mediaType: e ?? "application/xml"
    /* APPLICATION_XML */
  }),
  /**
   * Creates form-encoded content from FormData.
   */
  form: (t, e) => ({
    kind: "form",
    content: V.form(t),
    mediaType: e ?? "application/x-www-form-urlencoded"
    /* APPLICATION_FORM */
  }),
  /**
   * Creates binary content. Supports any binary format.
   */
  binary: (t, e = "application/octet-stream", r) => ({
    kind: "binary",
    content: V.binary(t),
    mediaType: e,
    filename: r
  }),
  /**
   * Creates multipart form content with file upload support.
   */
  multipart: (t, e) => ({
    kind: "multipart",
    content: V.multipart(t),
    mediaType: e ?? "multipart/form-data"
    /* MULTIPART_FORM */
  }),
  /**
   * Creates URL-encoded content from string or object.
   */
  urlencoded: (t, e) => ({
    kind: "urlencoded",
    content: V.urlencoded(t),
    mediaType: e ?? "application/x-www-form-urlencoded"
    /* APPLICATION_FORM */
  }),
  /**
   * Creates streaming content for large payloads.
   */
  stream: (t, e) => ({
    kind: "stream",
    content: V.stream(t),
    mediaType: e
  })
  // TODO: Raw content type for pass-through scenarios:
  // raw: (content: string, mediaType: MediaType | string): ContentType => ({
  //     kind: "raw",
  //     content,
  //     mediaType
  // })
};
H.text(
  '{"message": "Hello \\"world\\"", "path": "C:\\\\Users\\\\file.txt"}',
  "application/json"
  /* APPLICATION_JSON */
), H.json(
  { data: { type: "users", id: "1" } },
  "application/vnd.api+json"
), H.xml(
  "<soap:Envelope>...</soap:Envelope>",
  "application/soap+xml"
), H.binary(
  new Uint8Array([137, 80, 78, 71]),
  "image/png"
), H.json({ name: "John" }), H.text("Hello world");
const lr = async (t) => {
  const e = /* @__PURE__ */ new Map();
  for (const [r, n] of t.entries())
    if (n instanceof File || n instanceof Blob) {
      const s = await n.arrayBuffer(), a = {
        kind: "file",
        filename: n instanceof File ? n.name : "unknown",
        contentType: n.type || "application/octet-stream",
        data: new Uint8Array(s)
      };
      e.has(r) ? e.get(r).push(a) : e.set(r, [a]);
    } else {
      const s = {
        kind: "text",
        value: n.toString()
      };
      e.has(r) ? e.get(r).push(s) : e.set(r, [s]);
    }
  return Array.from(e.entries());
}, fr = async (t) => {
  var r;
  const e = { ...t };
  if (((r = e.content) == null ? void 0 : r.kind) === "multipart" && e.content.content instanceof FormData) {
    const n = await lr(e.content.content);
    e.content = {
      ...e.content,
      // Replace with the converted form data
      // SAFETY: Type assertion is necessary here because the plugin system expects
      // types similar to Map<string, FormDataValue[]> instead of FormData.
      // Then convert the `Map` to simpler nested `Array` of `Array` structure for better compatibility
      // `Maps` it seems like are serialized differently across platforms and serialization libraries,
      // while `Array` of `Array` tend to maintain more consistent behavior by the sheer ubiquity of it.
      // @ts-expect-error: This is intentional to work around SuperJSON serialization
      content: n
    };
  }
  return e;
};
function hr(t) {
  return function(e) {
    var r = {};
    for (var n in e)
      pt.call(e, n) && (r[n] = t(n, e[n]));
    return r;
  };
}
function mr(t) {
  return hr(function(e, r) {
    return t(r);
  });
}
function pr(t) {
  return function(e) {
    var r = {}, n = !1;
    for (var s in e)
      if (pt.call(e, s)) {
        var a = e[s];
        t(s, a) ? r[s] = a : n = !0;
      }
    return n ? r : e;
  };
}
var yr = mr;
function gr(t) {
  return pr(t);
}
const _r = (t) => t >= 100 && t < 600, vr = (t) => Me(
  t,
  gr((e, r) => r !== void 0),
  yr(String)
), wr = {
  api: {
    id: "axios",
    capabilities: {
      method: /* @__PURE__ */ new Set([
        "GET",
        "POST",
        "PUT",
        "DELETE",
        "PATCH",
        "HEAD",
        "OPTIONS"
      ]),
      header: /* @__PURE__ */ new Set(["stringvalue", "arrayvalue", "multivalue"]),
      content: /* @__PURE__ */ new Set([
        "text",
        "json",
        "xml",
        "form",
        "urlencoded",
        "compression"
      ]),
      auth: /* @__PURE__ */ new Set(["basic", "bearer", "apikey", "aws"]),
      security: /* @__PURE__ */ new Set([]),
      proxy: /* @__PURE__ */ new Set([]),
      advanced: /* @__PURE__ */ new Set([])
    },
    canHandle(t) {
      var e;
      return this.capabilities.method.has(t.method) ? t.content && !this.capabilities.content.has(t.content.kind) ? w({
        kind: "unsupported_feature",
        feature: "content",
        message: `Content type ${t.content.kind} is not supported`,
        relay: "axios"
      }) : t.auth && !this.capabilities.auth.has(t.auth.kind) ? w({
        kind: "unsupported_feature",
        feature: "authentication",
        message: `Authentication type ${t.auth.kind} is not supported`,
        relay: "axios"
      }) : (e = t.security) != null && e.certificates ? w({
        kind: "unsupported_feature",
        feature: "security",
        message: "Client certificates are not supported",
        relay: "axios"
      }) : t.proxy ? w({
        kind: "unsupported_feature",
        feature: "proxy",
        message: "Proxy is not supported",
        relay: "axios"
      }) : T(!0) : w({
        kind: "unsupported_feature",
        feature: "method",
        message: `Method ${t.method} is not supported`,
        relay: "axios"
      });
    },
    execute(t) {
      const e = le.CancelToken.source(), r = {
        on: () => () => {
        },
        once: () => () => {
        },
        off: () => {
        }
      }, n = (async () => {
        var s, a, i, o, d, l, p;
        try {
          const x = Date.now(), K = {
            url: t.url,
            method: t.method,
            headers: t.headers,
            params: t.params,
            data: (s = t.content) == null ? void 0 : s.content,
            maxRedirects: (i = (a = t.meta) == null ? void 0 : a.options) == null ? void 0 : i.maxRedirects,
            timeout: (d = (o = t.meta) == null ? void 0 : o.options) == null ? void 0 : d.timeout,
            decompress: ((p = (l = t.meta) == null ? void 0 : l.options) == null ? void 0 : p.decompress) ?? !0,
            validateStatus: null,
            cancelToken: e.token,
            responseType: "arraybuffer"
          }, S = await le(K), A = Date.now();
          if (!_r(S.status))
            return w({
              kind: "version",
              message: `Invalid status code: ${S.status}`
            });
          const P = vr(S.headers), Oe = P["content-type"] || P["Content-Type"] || P["CONTENT-TYPE"], Be = S.data.byteLength, Ke = JSON.stringify(S.headers).length, $t = {
            id: t.id,
            status: S.status,
            statusText: S.statusText,
            version: t.version,
            headers: P,
            body: gt.body(S.data, Oe),
            meta: {
              timing: {
                start: x,
                end: A
              },
              size: {
                headers: Ke,
                body: Be,
                total: Ke + Be
              }
            }
          };
          return T($t);
        } catch (x) {
          return le.isCancel(x) ? w({ kind: "abort", message: "Request cancelled" }) : le.isAxiosError(x) ? x.code === "ECONNABORTED" ? w({
            kind: "timeout",
            message: "Request timed out",
            phase: "response"
          }) : w({
            kind: "network",
            message: x.message
          }) : w({
            kind: "network",
            message: x instanceof Error ? x.message : "Unknown error occurred",
            cause: x
          });
        }
      })();
      return {
        cancel: async () => {
          e.cancel();
        },
        emitter: r,
        response: n
      };
    }
  }
}, kr = {
  v1: wr
};
var Ge;
(function(t) {
  t.TEXT_PLAIN = "text/plain", t.TEXT_HTML = "text/html", t.TEXT_CSS = "text/css", t.TEXT_CSV = "text/csv", t.APPLICATION_JSON = "application/json", t.APPLICATION_LD_JSON = "application/ld+json", t.APPLICATION_XML = "application/xml", t.TEXT_XML = "text/xml", t.APPLICATION_FORM = "application/x-www-form-urlencoded", t.APPLICATION_OCTET = "application/octet-stream", t.MULTIPART_FORM = "multipart/form-data";
})(Ge || (Ge = {}));
async function xr(t) {
  return await b("plugin:relay|execute", { request: t });
}
async function br(t) {
  return await b("plugin:relay|cancel", { requestId: t });
}
const Er = {
  api: {
    id: "desktop",
    capabilities: {
      method: /* @__PURE__ */ new Set([
        "GET",
        "POST",
        "PUT",
        "DELETE",
        "PATCH",
        "HEAD",
        "OPTIONS"
      ]),
      header: /* @__PURE__ */ new Set([
        "stringvalue",
        "arrayvalue",
        "multivalue"
      ]),
      content: /* @__PURE__ */ new Set([
        "text",
        "json",
        "xml",
        "form",
        "binary",
        "multipart",
        "urlencoded",
        "stream",
        "compression"
      ]),
      auth: /* @__PURE__ */ new Set([
        "basic",
        "bearer",
        "digest",
        "oauth2",
        "apikey"
      ]),
      security: /* @__PURE__ */ new Set([
        "clientcertificates",
        "cacertificates",
        "certificatevalidation",
        "hostverification",
        "peerverification"
      ]),
      proxy: /* @__PURE__ */ new Set([
        "http",
        "https",
        "authentication",
        "certificates"
      ]),
      advanced: /* @__PURE__ */ new Set([
        "retry",
        "redirects",
        "timeout",
        "cookies",
        "keepalive",
        "tcpoptions",
        "http2",
        "http3"
      ])
    },
    canHandle(t) {
      var e;
      return this.capabilities.method.has(t.method) ? t.content && !this.capabilities.content.has(t.content.kind) ? w({
        kind: "unsupported_feature",
        feature: "content",
        message: `Content type ${t.content.kind} is not supported`,
        relay: "desktop"
      }) : t.auth && !this.capabilities.auth.has(t.auth.kind) ? w({
        kind: "unsupported_feature",
        feature: "authentication",
        message: `Authentication type ${t.auth.kind} is not supported`,
        relay: "desktop"
      }) : (e = t.security) != null && e.certificates && !this.capabilities.security.has("clientcertificates") ? w({
        kind: "unsupported_feature",
        feature: "security",
        message: "Client certificates are not supported",
        relay: "desktop"
      }) : t.proxy && !this.capabilities.proxy.has(t.proxy.url.startsWith("https") ? "https" : "http") ? w({
        kind: "unsupported_feature",
        feature: "proxy",
        message: `Proxy protocol ${t.proxy.url.split(":")[0]} is not supported`,
        relay: "desktop"
      }) : T(!0) : w({
        kind: "unsupported_feature",
        feature: "method",
        message: `Method ${t.method} is not supported`,
        relay: "desktop"
      });
    },
    execute(t) {
      const e = {
        on: () => () => {
        },
        once: () => () => {
        },
        off: () => {
        }
      }, r = fr(t).then((n) => {
        const s = {
          id: n.id,
          url: n.url,
          method: n.method,
          version: n.version,
          headers: n.headers,
          params: n.params,
          content: n.content,
          auth: n.auth,
          security: n.security,
          proxy: n.proxy
        };
        return xr(s);
      }).then((n) => {
        if (n.kind === "success") {
          const s = {
            id: n.response.id,
            status: n.response.status,
            statusText: n.response.statusText,
            version: n.response.version,
            headers: n.response.headers,
            cookies: n.response.cookies,
            body: gt.body(n.response.body.body, n.response.body.mediaType),
            meta: {
              timing: {
                start: n.response.meta.timing.start,
                end: n.response.meta.timing.end
              },
              size: n.response.meta.size
            }
          };
          return T(s);
        }
        return w(n.error);
      }).catch((n) => {
        const s = {
          kind: "network",
          message: n instanceof Error ? n.message : "Unknown error occurred",
          cause: n
        };
        return w(s);
      });
      return {
        cancel: async () => {
          await br(t.id);
        },
        emitter: e,
        response: r
      };
    }
  }
}, Tr = {
  v1: Er
};
class Sr {
  constructor() {
    this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
  }
  set(e, r) {
    this.keyToValue.set(e, r), this.valueToKey.set(r, e);
  }
  getByKey(e) {
    return this.keyToValue.get(e);
  }
  getByValue(e) {
    return this.valueToKey.get(e);
  }
  clear() {
    this.keyToValue.clear(), this.valueToKey.clear();
  }
}
class _t {
  constructor(e) {
    this.generateIdentifier = e, this.kv = new Sr();
  }
  register(e, r) {
    this.kv.getByValue(e) || (r || (r = this.generateIdentifier(e)), this.kv.set(r, e));
  }
  clear() {
    this.kv.clear();
  }
  getIdentifier(e) {
    return this.kv.getByValue(e);
  }
  getValue(e) {
    return this.kv.getByKey(e);
  }
}
class Or extends _t {
  constructor() {
    super((e) => e.name), this.classToAllowedProps = /* @__PURE__ */ new Map();
  }
  register(e, r) {
    typeof r == "object" ? (r.allowProps && this.classToAllowedProps.set(e, r.allowProps), super.register(e, r.identifier)) : super.register(e, r);
  }
  getAllowedProps(e) {
    return this.classToAllowedProps.get(e);
  }
}
function Ar(t) {
  if ("values" in Object)
    return Object.values(t);
  const e = [];
  for (const r in t)
    t.hasOwnProperty(r) && e.push(t[r]);
  return e;
}
function Rr(t, e) {
  const r = Ar(t);
  if ("find" in r)
    return r.find(e);
  const n = r;
  for (let s = 0; s < n.length; s++) {
    const a = n[s];
    if (e(a))
      return a;
  }
}
function J(t, e) {
  Object.entries(t).forEach(([r, n]) => e(n, r));
}
function he(t, e) {
  return t.indexOf(e) !== -1;
}
function Je(t, e) {
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    if (e(n))
      return n;
  }
}
class Nr {
  constructor() {
    this.transfomers = {};
  }
  register(e) {
    this.transfomers[e.name] = e;
  }
  findApplicable(e) {
    return Rr(this.transfomers, (r) => r.isApplicable(e));
  }
  findByName(e) {
    return this.transfomers[e];
  }
}
const Ir = (t) => Object.prototype.toString.call(t).slice(8, -1), vt = (t) => typeof t > "u", Cr = (t) => t === null, ie = (t) => typeof t != "object" || t === null || t === Object.prototype ? !1 : Object.getPrototypeOf(t) === null ? !0 : Object.getPrototypeOf(t) === Object.prototype, Ie = (t) => ie(t) && Object.keys(t).length === 0, F = (t) => Array.isArray(t), Pr = (t) => typeof t == "string", jr = (t) => typeof t == "number" && !isNaN(t), Zr = (t) => typeof t == "boolean", $r = (t) => t instanceof RegExp, oe = (t) => t instanceof Map, ce = (t) => t instanceof Set, wt = (t) => Ir(t) === "Symbol", Lr = (t) => t instanceof Date && !isNaN(t.valueOf()), Dr = (t) => t instanceof Error, Ye = (t) => typeof t == "number" && isNaN(t), Vr = (t) => Zr(t) || Cr(t) || vt(t) || jr(t) || Pr(t) || wt(t), Ur = (t) => typeof t == "bigint", zr = (t) => t === 1 / 0 || t === -1 / 0, Mr = (t) => ArrayBuffer.isView(t) && !(t instanceof DataView), Fr = (t) => t instanceof URL, kt = (t) => t.replace(/\./g, "\\."), Re = (t) => t.map(String).map(kt).join("."), ae = (t) => {
  const e = [];
  let r = "";
  for (let s = 0; s < t.length; s++) {
    let a = t.charAt(s);
    if (a === "\\" && t.charAt(s + 1) === ".") {
      r += ".", s++;
      continue;
    }
    if (a === ".") {
      e.push(r), r = "";
      continue;
    }
    r += a;
  }
  const n = r;
  return e.push(n), e;
};
function j(t, e, r, n) {
  return {
    isApplicable: t,
    annotation: e,
    transform: r,
    untransform: n
  };
}
const xt = [
  j(vt, "undefined", () => null, () => {
  }),
  j(Ur, "bigint", (t) => t.toString(), (t) => typeof BigInt < "u" ? BigInt(t) : (console.error("Please add a BigInt polyfill."), t)),
  j(Lr, "Date", (t) => t.toISOString(), (t) => new Date(t)),
  j(Dr, "Error", (t, e) => {
    const r = {
      name: t.name,
      message: t.message
    };
    return e.allowedErrorProps.forEach((n) => {
      r[n] = t[n];
    }), r;
  }, (t, e) => {
    const r = new Error(t.message);
    return r.name = t.name, r.stack = t.stack, e.allowedErrorProps.forEach((n) => {
      r[n] = t[n];
    }), r;
  }),
  j($r, "regexp", (t) => "" + t, (t) => {
    const e = t.slice(1, t.lastIndexOf("/")), r = t.slice(t.lastIndexOf("/") + 1);
    return new RegExp(e, r);
  }),
  j(
    ce,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    (t) => [...t.values()],
    (t) => new Set(t)
  ),
  j(oe, "map", (t) => [...t.entries()], (t) => new Map(t)),
  j((t) => Ye(t) || zr(t), "number", (t) => Ye(t) ? "NaN" : t > 0 ? "Infinity" : "-Infinity", Number),
  j((t) => t === 0 && 1 / t === -1 / 0, "number", () => "-0", Number),
  j(Fr, "URL", (t) => t.toString(), (t) => new URL(t))
];
function Se(t, e, r, n) {
  return {
    isApplicable: t,
    annotation: e,
    transform: r,
    untransform: n
  };
}
const bt = Se((t, e) => wt(t) ? !!e.symbolRegistry.getIdentifier(t) : !1, (t, e) => ["symbol", e.symbolRegistry.getIdentifier(t)], (t) => t.description, (t, e, r) => {
  const n = r.symbolRegistry.getValue(e[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown symbol");
  return n;
}), Wr = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce((t, e) => (t[e.name] = e, t), {}), Et = Se(Mr, (t) => ["typed-array", t.constructor.name], (t) => [...t], (t, e) => {
  const r = Wr[e[1]];
  if (!r)
    throw new Error("Trying to deserialize unknown typed array");
  return new r(t);
});
function Tt(t, e) {
  return t != null && t.constructor ? !!e.classRegistry.getIdentifier(t.constructor) : !1;
}
const St = Se(Tt, (t, e) => ["class", e.classRegistry.getIdentifier(t.constructor)], (t, e) => {
  const r = e.classRegistry.getAllowedProps(t.constructor);
  if (!r)
    return { ...t };
  const n = {};
  return r.forEach((s) => {
    n[s] = t[s];
  }), n;
}, (t, e, r) => {
  const n = r.classRegistry.getValue(e[1]);
  if (!n)
    throw new Error(`Trying to deserialize unknown class '${e[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`);
  return Object.assign(Object.create(n.prototype), t);
}), Ot = Se((t, e) => !!e.customTransformerRegistry.findApplicable(t), (t, e) => ["custom", e.customTransformerRegistry.findApplicable(t).name], (t, e) => e.customTransformerRegistry.findApplicable(t).serialize(t), (t, e, r) => {
  const n = r.customTransformerRegistry.findByName(e[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown custom value");
  return n.deserialize(t);
}), Br = [St, bt, Ot, Et], Qe = (t, e) => {
  const r = Je(Br, (s) => s.isApplicable(t, e));
  if (r)
    return {
      value: r.transform(t, e),
      type: r.annotation(t, e)
    };
  const n = Je(xt, (s) => s.isApplicable(t, e));
  if (n)
    return {
      value: n.transform(t, e),
      type: n.annotation
    };
}, At = {};
xt.forEach((t) => {
  At[t.annotation] = t;
});
const Kr = (t, e, r) => {
  if (F(e))
    switch (e[0]) {
      case "symbol":
        return bt.untransform(t, e, r);
      case "class":
        return St.untransform(t, e, r);
      case "custom":
        return Ot.untransform(t, e, r);
      case "typed-array":
        return Et.untransform(t, e, r);
      default:
        throw new Error("Unknown transformation: " + e);
    }
  else {
    const n = At[e];
    if (!n)
      throw new Error("Unknown transformation: " + e);
    return n.untransform(t, r);
  }
}, G = (t, e) => {
  if (e > t.size)
    throw new Error("index out of bounds");
  const r = t.keys();
  for (; e > 0; )
    r.next(), e--;
  return r.next().value;
};
function Rt(t) {
  if (he(t, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (he(t, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (he(t, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
const Hr = (t, e) => {
  Rt(e);
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (ce(t))
      t = G(t, +n);
    else if (oe(t)) {
      const s = +n, a = +e[++r] == 0 ? "key" : "value", i = G(t, s);
      switch (a) {
        case "key":
          t = i;
          break;
        case "value":
          t = t.get(i);
          break;
      }
    } else
      t = t[n];
  }
  return t;
}, Ce = (t, e, r) => {
  if (Rt(e), e.length === 0)
    return r(t);
  let n = t;
  for (let a = 0; a < e.length - 1; a++) {
    const i = e[a];
    if (F(n)) {
      const o = +i;
      n = n[o];
    } else if (ie(n))
      n = n[i];
    else if (ce(n)) {
      const o = +i;
      n = G(n, o);
    } else if (oe(n)) {
      if (a === e.length - 2)
        break;
      const d = +i, l = +e[++a] == 0 ? "key" : "value", p = G(n, d);
      switch (l) {
        case "key":
          n = p;
          break;
        case "value":
          n = n.get(p);
          break;
      }
    }
  }
  const s = e[e.length - 1];
  if (F(n) ? n[+s] = r(n[+s]) : ie(n) && (n[s] = r(n[s])), ce(n)) {
    const a = G(n, +s), i = r(a);
    a !== i && (n.delete(a), n.add(i));
  }
  if (oe(n)) {
    const a = +e[e.length - 2], i = G(n, a);
    switch (+s == 0 ? "key" : "value") {
      case "key": {
        const d = r(i);
        n.set(d, n.get(i)), d !== i && n.delete(i);
        break;
      }
      case "value": {
        n.set(i, r(n.get(i)));
        break;
      }
    }
  }
  return t;
};
function Pe(t, e, r = []) {
  if (!t)
    return;
  if (!F(t)) {
    J(t, (a, i) => Pe(a, e, [...r, ...ae(i)]));
    return;
  }
  const [n, s] = t;
  s && J(s, (a, i) => {
    Pe(a, e, [...r, ...ae(i)]);
  }), e(n, r);
}
function Xr(t, e, r) {
  return Pe(e, (n, s) => {
    t = Ce(t, s, (a) => Kr(a, n, r));
  }), t;
}
function Gr(t, e) {
  function r(n, s) {
    const a = Hr(t, ae(s));
    n.map(ae).forEach((i) => {
      t = Ce(t, i, () => a);
    });
  }
  if (F(e)) {
    const [n, s] = e;
    n.forEach((a) => {
      t = Ce(t, ae(a), () => t);
    }), s && J(s, r);
  } else
    J(e, r);
  return t;
}
const Jr = (t, e) => ie(t) || F(t) || oe(t) || ce(t) || Tt(t, e);
function Yr(t, e, r) {
  const n = r.get(t);
  n ? n.push(e) : r.set(t, [e]);
}
function Qr(t, e) {
  const r = {};
  let n;
  return t.forEach((s) => {
    if (s.length <= 1)
      return;
    e || (s = s.map((o) => o.map(String)).sort((o, d) => o.length - d.length));
    const [a, ...i] = s;
    a.length === 0 ? n = i.map(Re) : r[Re(a)] = i.map(Re);
  }), n ? Ie(r) ? [n] : [n, r] : Ie(r) ? void 0 : r;
}
const Nt = (t, e, r, n, s = [], a = [], i = /* @__PURE__ */ new Map()) => {
  const o = Vr(t);
  if (!o) {
    Yr(t, s, e);
    const S = i.get(t);
    if (S)
      return n ? {
        transformedValue: null
      } : S;
  }
  if (!Jr(t, r)) {
    const S = Qe(t, r), A = S ? {
      transformedValue: S.value,
      annotations: [S.type]
    } : {
      transformedValue: t
    };
    return o || i.set(t, A), A;
  }
  if (he(a, t))
    return {
      transformedValue: null
    };
  const d = Qe(t, r), l = (d == null ? void 0 : d.value) ?? t, p = F(l) ? [] : {}, x = {};
  J(l, (S, A) => {
    if (A === "__proto__" || A === "constructor" || A === "prototype")
      throw new Error(`Detected property ${A}. This is a prototype pollution risk, please remove it from your object.`);
    const P = Nt(S, e, r, n, [...s, A], [...a, t], i);
    p[A] = P.transformedValue, F(P.annotations) ? x[A] = P.annotations : ie(P.annotations) && J(P.annotations, (Oe, We) => {
      x[kt(A) + "." + We] = Oe;
    });
  });
  const K = Ie(x) ? {
    transformedValue: p,
    annotations: d ? [d.type] : void 0
  } : {
    transformedValue: p,
    annotations: d ? [d.type, x] : x
  };
  return o || i.set(t, K), K;
};
function It(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function qe(t) {
  return It(t) === "Array";
}
function qr(t) {
  if (It(t) !== "Object")
    return !1;
  const e = Object.getPrototypeOf(t);
  return !!e && e.constructor === Object && e === Object.prototype;
}
function en(t, e, r, n, s) {
  const a = {}.propertyIsEnumerable.call(n, e) ? "enumerable" : "nonenumerable";
  a === "enumerable" && (t[e] = r), s && a === "nonenumerable" && Object.defineProperty(t, e, {
    value: r,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function je(t, e = {}) {
  if (qe(t))
    return t.map((s) => je(s, e));
  if (!qr(t))
    return t;
  const r = Object.getOwnPropertyNames(t), n = Object.getOwnPropertySymbols(t);
  return [...r, ...n].reduce((s, a) => {
    if (qe(e.props) && !e.props.includes(a))
      return s;
    const i = t[a], o = je(i, e);
    return en(s, a, o, t, e.nonenumerable), s;
  }, {});
}
class _ {
  /**
   * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
   */
  constructor({ dedupe: e = !1 } = {}) {
    this.classRegistry = new Or(), this.symbolRegistry = new _t((r) => r.description ?? ""), this.customTransformerRegistry = new Nr(), this.allowedErrorProps = [], this.dedupe = e;
  }
  serialize(e) {
    const r = /* @__PURE__ */ new Map(), n = Nt(e, r, this, this.dedupe), s = {
      json: n.transformedValue
    };
    n.annotations && (s.meta = {
      ...s.meta,
      values: n.annotations
    });
    const a = Qr(r, this.dedupe);
    return a && (s.meta = {
      ...s.meta,
      referentialEqualities: a
    }), s;
  }
  deserialize(e) {
    const { json: r, meta: n } = e;
    let s = je(r);
    return n != null && n.values && (s = Xr(s, n.values, this)), n != null && n.referentialEqualities && (s = Gr(s, n.referentialEqualities)), s;
  }
  stringify(e) {
    return JSON.stringify(this.serialize(e));
  }
  parse(e) {
    return this.deserialize(JSON.parse(e));
  }
  registerClass(e, r) {
    this.classRegistry.register(e, r);
  }
  registerSymbol(e, r) {
    this.symbolRegistry.register(e, r);
  }
  registerCustom(e, r) {
    this.customTransformerRegistry.register({
      name: r,
      ...e
    });
  }
  allowErrorProps(...e) {
    this.allowedErrorProps.push(...e);
  }
}
_.defaultInstance = new _();
_.serialize = _.defaultInstance.serialize.bind(_.defaultInstance);
_.deserialize = _.defaultInstance.deserialize.bind(_.defaultInstance);
_.stringify = _.defaultInstance.stringify.bind(_.defaultInstance);
_.parse = _.defaultInstance.parse.bind(_.defaultInstance);
_.registerClass = _.defaultInstance.registerClass.bind(_.defaultInstance);
_.registerSymbol = _.defaultInstance.registerSymbol.bind(_.defaultInstance);
_.registerCustom = _.defaultInstance.registerCustom.bind(_.defaultInstance);
_.allowErrorProps = _.defaultInstance.allowErrorProps.bind(_.defaultInstance);
_.serialize;
_.deserialize;
_.stringify;
_.parse;
_.registerClass;
_.registerCustom;
_.registerSymbol;
_.allowErrorProps;
var k;
(function(t) {
  t.assertEqual = (s) => {
  };
  function e(s) {
  }
  t.assertIs = e;
  function r(s) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (s) => {
    const a = {};
    for (const i of s)
      a[i] = i;
    return a;
  }, t.getValidEnumValues = (s) => {
    const a = t.objectKeys(s).filter((o) => typeof s[s[o]] != "number"), i = {};
    for (const o of a)
      i[o] = s[o];
    return t.objectValues(i);
  }, t.objectValues = (s) => t.objectKeys(s).map(function(a) {
    return s[a];
  }), t.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const a = [];
    for (const i in s)
      Object.prototype.hasOwnProperty.call(s, i) && a.push(i);
    return a;
  }, t.find = (s, a) => {
    for (const i of s)
      if (a(i))
        return i;
  }, t.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && Number.isFinite(s) && Math.floor(s) === s;
  function n(s, a = " | ") {
    return s.map((i) => typeof i == "string" ? `'${i}'` : i).join(a);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (s, a) => typeof a == "bigint" ? a.toString() : a;
})(k || (k = {}));
var et;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(et || (et = {}));
const f = k.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), U = (t) => {
  switch (typeof t) {
    case "undefined":
      return f.undefined;
    case "string":
      return f.string;
    case "number":
      return Number.isNaN(t) ? f.nan : f.number;
    case "boolean":
      return f.boolean;
    case "function":
      return f.function;
    case "bigint":
      return f.bigint;
    case "symbol":
      return f.symbol;
    case "object":
      return Array.isArray(t) ? f.array : t === null ? f.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? f.promise : typeof Map < "u" && t instanceof Map ? f.map : typeof Set < "u" && t instanceof Set ? f.set : typeof Date < "u" && t instanceof Date ? f.date : f.object;
    default:
      return f.unknown;
  }
}, c = k.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class D extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(a) {
      return a.message;
    }, n = { _errors: [] }, s = (a) => {
      for (const i of a.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(s);
        else if (i.code === "invalid_return_type")
          s(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          s(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, d = 0;
          for (; d < i.path.length; ) {
            const l = i.path[d];
            d === i.path.length - 1 ? (o[l] = o[l] || { _errors: [] }, o[l]._errors.push(r(i))) : o[l] = o[l] || { _errors: [] }, o = o[l], d++;
          }
        }
    };
    return s(this), n;
  }
  static assert(e) {
    if (!(e instanceof D))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, k.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const s of this.issues)
      s.path.length > 0 ? (r[s.path[0]] = r[s.path[0]] || [], r[s.path[0]].push(e(s))) : n.push(e(s));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
D.create = (t) => new D(t);
const Ze = (t, e) => {
  let r;
  switch (t.code) {
    case c.invalid_type:
      t.received === f.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case c.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, k.jsonStringifyReplacer)}`;
      break;
    case c.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${k.joinValues(t.keys, ", ")}`;
      break;
    case c.invalid_union:
      r = "Invalid input";
      break;
    case c.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${k.joinValues(t.options)}`;
      break;
    case c.invalid_enum_value:
      r = `Invalid enum value. Expected ${k.joinValues(t.options)}, received '${t.received}'`;
      break;
    case c.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case c.invalid_return_type:
      r = "Invalid function return type";
      break;
    case c.invalid_date:
      r = "Invalid date";
      break;
    case c.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : k.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case c.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case c.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case c.custom:
      r = "Invalid input";
      break;
    case c.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case c.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case c.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, k.assertNever(t);
  }
  return { message: r };
};
let tn = Ze;
function rn() {
  return tn;
}
const nn = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: s } = t, a = [...r, ...s.path || []], i = {
    ...s,
    path: a
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: a,
      message: s.message
    };
  let o = "";
  const d = n.filter((l) => !!l).slice().reverse();
  for (const l of d)
    o = l(i, { data: e, defaultError: o }).message;
  return {
    ...s,
    path: a,
    message: o
  };
};
function u(t, e) {
  const r = rn(), n = nn({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === Ze ? void 0 : Ze
      // then global default map
    ].filter((s) => !!s)
  });
  t.common.issues.push(n);
}
class O {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const s of r) {
      if (s.status === "aborted")
        return y;
      s.status === "dirty" && e.dirty(), n.push(s.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const s of r) {
      const a = await s.key, i = await s.value;
      n.push({
        key: a,
        value: i
      });
    }
    return O.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const s of r) {
      const { key: a, value: i } = s;
      if (a.status === "aborted" || i.status === "aborted")
        return y;
      a.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof i.value < "u" || s.alwaysSet) && (n[a.value] = i.value);
    }
    return { status: e.value, value: n };
  }
}
const y = Object.freeze({
  status: "aborted"
}), re = (t) => ({ status: "dirty", value: t }), I = (t) => ({ status: "valid", value: t }), tt = (t) => t.status === "aborted", rt = (t) => t.status === "dirty", Y = (t) => t.status === "valid", pe = (t) => typeof Promise < "u" && t instanceof Promise;
var h;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(h || (h = {}));
var ye = function(t, e, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !n : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(t) : n ? n.value : e.get(t);
}, Ct = function(t, e, r, n, s) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !s) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !s : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? s.call(t, r) : s ? s.value = r : e.set(t, r), r;
}, ne, se;
class $ {
  constructor(e, r, n, s) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const nt = (t, e) => {
  if (Y(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new D(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function g(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: s } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (i, o) => {
    const { message: d } = t;
    return i.code === "invalid_enum_value" ? { message: d ?? o.defaultError } : typeof o.data > "u" ? { message: d ?? n ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: d ?? r ?? o.defaultError };
  }, description: s };
}
class v {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return U(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: U(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new O(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: U(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (pe(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    const n = {
      common: {
        issues: [],
        async: (r == null ? void 0 : r.async) ?? !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: U(e)
    }, s = this._parseSync({ data: e, path: n.path, parent: n });
    return nt(n, s);
  }
  "~validate"(e) {
    var n, s;
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: U(e)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: e, path: [], parent: r });
        return Y(a) ? {
          value: a.value
        } : {
          issues: r.common.issues
        };
      } catch (a) {
        (s = (n = a == null ? void 0 : a.message) == null ? void 0 : n.toLowerCase()) != null && s.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: r }).then((a) => Y(a) ? {
      value: a.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: U(e)
    }, s = this._parse({ data: e, path: n.path, parent: n }), a = await (pe(s) ? s : Promise.resolve(s));
    return nt(n, a);
  }
  refine(e, r) {
    const n = (s) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(s) : r;
    return this._refinement((s, a) => {
      const i = e(s), o = () => a.addIssue({
        code: c.custom,
        ...n(s)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((d) => d ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, s) => e(n) ? !0 : (s.addIssue(typeof r == "function" ? r(n, s) : r), !1));
  }
  _refinement(e) {
    return new ee({
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return M.create(this, this._def);
  }
  nullable() {
    return te.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Z.create(this);
  }
  promise() {
    return ke.create(this, this._def);
  }
  or(e) {
    return _e.create([this, e], this._def);
  }
  and(e) {
    return ve.create(this, e, this._def);
  }
  transform(e) {
    return new ee({
      ...g(this._def),
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Ve({
      ...g(this._def),
      innerType: this,
      defaultValue: r,
      typeName: m.ZodDefault
    });
  }
  brand() {
    return new On({
      typeName: m.ZodBranded,
      type: this,
      ...g(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Ue({
      ...g(this._def),
      innerType: this,
      catchValue: r,
      typeName: m.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Fe.create(this, e);
  }
  readonly() {
    return ze.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const sn = /^c[^\s-]{8,}$/i, an = /^[0-9a-z]+$/, on = /^[0-9A-HJKMNP-TV-Z]{26}$/i, cn = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, dn = /^[a-z0-9_-]{21}$/i, un = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, ln = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, fn = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, hn = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Ne;
const mn = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, pn = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, yn = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, gn = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, _n = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, vn = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Pt = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", wn = new RegExp(`^${Pt}$`);
function jt(t) {
  let e = "[0-5]\\d";
  t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`);
  const r = t.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${r}`;
}
function kn(t) {
  return new RegExp(`^${jt(t)}$`);
}
function xn(t) {
  let e = `${Pt}T${jt(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function bn(t, e) {
  return !!((e === "v4" || !e) && mn.test(t) || (e === "v6" || !e) && yn.test(t));
}
function En(t, e) {
  if (!un.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), s = JSON.parse(atob(n));
    return !(typeof s != "object" || s === null || "typ" in s && (s == null ? void 0 : s.typ) !== "JWT" || !s.alg || e && s.alg !== e);
  } catch {
    return !1;
  }
}
function Tn(t, e) {
  return !!((e === "v4" || !e) && pn.test(t) || (e === "v6" || !e) && gn.test(t));
}
class L extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== f.string) {
      const a = this._getOrReturnCtx(e);
      return u(a, {
        code: c.invalid_type,
        expected: f.string,
        received: a.parsedType
      }), y;
    }
    const n = new O();
    let s;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (s = this._getOrReturnCtx(e, s), u(s, {
          code: c.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (s = this._getOrReturnCtx(e, s), u(s, {
          code: c.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "length") {
        const i = e.data.length > a.value, o = e.data.length < a.value;
        (i || o) && (s = this._getOrReturnCtx(e, s), i ? u(s, {
          code: c.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : o && u(s, {
          code: c.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), n.dirty());
      } else if (a.kind === "email")
        fn.test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
          validation: "email",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "emoji")
        Ne || (Ne = new RegExp(hn, "u")), Ne.test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
          validation: "emoji",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "uuid")
        cn.test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
          validation: "uuid",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "nanoid")
        dn.test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
          validation: "nanoid",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid")
        sn.test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
          validation: "cuid",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid2")
        an.test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
          validation: "cuid2",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "ulid")
        on.test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
          validation: "ulid",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), u(s, {
            validation: "url",
            code: c.invalid_string,
            message: a.message
          }), n.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
        validation: "regex",
        code: c.invalid_string,
        message: a.message
      }), n.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (s = this._getOrReturnCtx(e, s), u(s, {
        code: c.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), n.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (s = this._getOrReturnCtx(e, s), u(s, {
        code: c.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (s = this._getOrReturnCtx(e, s), u(s, {
        code: c.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "datetime" ? xn(a).test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
        code: c.invalid_string,
        validation: "datetime",
        message: a.message
      }), n.dirty()) : a.kind === "date" ? wn.test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
        code: c.invalid_string,
        validation: "date",
        message: a.message
      }), n.dirty()) : a.kind === "time" ? kn(a).test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
        code: c.invalid_string,
        validation: "time",
        message: a.message
      }), n.dirty()) : a.kind === "duration" ? ln.test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
        validation: "duration",
        code: c.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "ip" ? bn(e.data, a.version) || (s = this._getOrReturnCtx(e, s), u(s, {
        validation: "ip",
        code: c.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "jwt" ? En(e.data, a.alg) || (s = this._getOrReturnCtx(e, s), u(s, {
        validation: "jwt",
        code: c.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "cidr" ? Tn(e.data, a.version) || (s = this._getOrReturnCtx(e, s), u(s, {
        validation: "cidr",
        code: c.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "base64" ? _n.test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
        validation: "base64",
        code: c.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "base64url" ? vn.test(e.data) || (s = this._getOrReturnCtx(e, s), u(s, {
        validation: "base64url",
        code: c.invalid_string,
        message: a.message
      }), n.dirty()) : k.assertNever(a);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((s) => e.test(s), {
      validation: r,
      code: c.invalid_string,
      ...h.errToObj(n)
    });
  }
  _addCheck(e) {
    return new L({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...h.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...h.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...h.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...h.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...h.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...h.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...h.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...h.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...h.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...h.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...h.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...h.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...h.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (e == null ? void 0 : e.offset) ?? !1,
      local: (e == null ? void 0 : e.local) ?? !1,
      ...h.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...h.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...h.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...h.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...h.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...h.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...h.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...h.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...h.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...h.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, h.errToObj(e));
  }
  trim() {
    return new L({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new L({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new L({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
L.create = (t) => new L({
  checks: [],
  typeName: m.ZodString,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...g(t)
});
function Sn(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, s = r > n ? r : n, a = Number.parseInt(t.toFixed(s).replace(".", "")), i = Number.parseInt(e.toFixed(s).replace(".", ""));
  return a % i / 10 ** s;
}
class Q extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== f.number) {
      const a = this._getOrReturnCtx(e);
      return u(a, {
        code: c.invalid_type,
        expected: f.number,
        received: a.parsedType
      }), y;
    }
    let n;
    const s = new O();
    for (const a of this._def.checks)
      a.kind === "int" ? k.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), u(n, {
        code: c.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), s.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), u(n, {
        code: c.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), u(n, {
        code: c.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? Sn(e.data, a.value) !== 0 && (n = this._getOrReturnCtx(e, n), u(n, {
        code: c.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), u(n, {
        code: c.not_finite,
        message: a.message
      }), s.dirty()) : k.assertNever(a);
    return { status: s.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, h.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, h.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, h.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, h.toString(r));
  }
  setLimit(e, r, n, s) {
    return new Q({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: h.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Q({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: h.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: h.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: h.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: h.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: h.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: h.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: h.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: h.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: h.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && k.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
Q.create = (t) => new Q({
  checks: [],
  typeName: m.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...g(t)
});
class de extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== f.bigint)
      return this._getInvalidInput(e);
    let n;
    const s = new O();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), u(n, {
        code: c.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), u(n, {
        code: c.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), u(n, {
        code: c.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : k.assertNever(a);
    return { status: s.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return u(r, {
      code: c.invalid_type,
      expected: f.bigint,
      received: r.parsedType
    }), y;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, h.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, h.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, h.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, h.toString(r));
  }
  setLimit(e, r, n, s) {
    return new de({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: h.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new de({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: h.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: h.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: h.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: h.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: h.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
de.create = (t) => new de({
  checks: [],
  typeName: m.ZodBigInt,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...g(t)
});
class $e extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== f.boolean) {
      const n = this._getOrReturnCtx(e);
      return u(n, {
        code: c.invalid_type,
        expected: f.boolean,
        received: n.parsedType
      }), y;
    }
    return I(e.data);
  }
}
$e.create = (t) => new $e({
  typeName: m.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...g(t)
});
class ge extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== f.date) {
      const a = this._getOrReturnCtx(e);
      return u(a, {
        code: c.invalid_type,
        expected: f.date,
        received: a.parsedType
      }), y;
    }
    if (Number.isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return u(a, {
        code: c.invalid_date
      }), y;
    }
    const n = new O();
    let s;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (s = this._getOrReturnCtx(e, s), u(s, {
        code: c.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), n.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (s = this._getOrReturnCtx(e, s), u(s, {
        code: c.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), n.dirty()) : k.assertNever(a);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new ge({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: h.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: h.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
ge.create = (t) => new ge({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: m.ZodDate,
  ...g(t)
});
class st extends v {
  _parse(e) {
    if (this._getType(e) !== f.symbol) {
      const n = this._getOrReturnCtx(e);
      return u(n, {
        code: c.invalid_type,
        expected: f.symbol,
        received: n.parsedType
      }), y;
    }
    return I(e.data);
  }
}
st.create = (t) => new st({
  typeName: m.ZodSymbol,
  ...g(t)
});
class at extends v {
  _parse(e) {
    if (this._getType(e) !== f.undefined) {
      const n = this._getOrReturnCtx(e);
      return u(n, {
        code: c.invalid_type,
        expected: f.undefined,
        received: n.parsedType
      }), y;
    }
    return I(e.data);
  }
}
at.create = (t) => new at({
  typeName: m.ZodUndefined,
  ...g(t)
});
class it extends v {
  _parse(e) {
    if (this._getType(e) !== f.null) {
      const n = this._getOrReturnCtx(e);
      return u(n, {
        code: c.invalid_type,
        expected: f.null,
        received: n.parsedType
      }), y;
    }
    return I(e.data);
  }
}
it.create = (t) => new it({
  typeName: m.ZodNull,
  ...g(t)
});
class ot extends v {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return I(e.data);
  }
}
ot.create = (t) => new ot({
  typeName: m.ZodAny,
  ...g(t)
});
class Le extends v {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return I(e.data);
  }
}
Le.create = (t) => new Le({
  typeName: m.ZodUnknown,
  ...g(t)
});
class W extends v {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return u(r, {
      code: c.invalid_type,
      expected: f.never,
      received: r.parsedType
    }), y;
  }
}
W.create = (t) => new W({
  typeName: m.ZodNever,
  ...g(t)
});
class ct extends v {
  _parse(e) {
    if (this._getType(e) !== f.undefined) {
      const n = this._getOrReturnCtx(e);
      return u(n, {
        code: c.invalid_type,
        expected: f.void,
        received: n.parsedType
      }), y;
    }
    return I(e.data);
  }
}
ct.create = (t) => new ct({
  typeName: m.ZodVoid,
  ...g(t)
});
class Z extends v {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), s = this._def;
    if (r.parsedType !== f.array)
      return u(r, {
        code: c.invalid_type,
        expected: f.array,
        received: r.parsedType
      }), y;
    if (s.exactLength !== null) {
      const i = r.data.length > s.exactLength.value, o = r.data.length < s.exactLength.value;
      (i || o) && (u(r, {
        code: i ? c.too_big : c.too_small,
        minimum: o ? s.exactLength.value : void 0,
        maximum: i ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), n.dirty());
    }
    if (s.minLength !== null && r.data.length < s.minLength.value && (u(r, {
      code: c.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), n.dirty()), s.maxLength !== null && r.data.length > s.maxLength.value && (u(r, {
      code: c.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => s.type._parseAsync(new $(r, i, r.path, o)))).then((i) => O.mergeArray(n, i));
    const a = [...r.data].map((i, o) => s.type._parseSync(new $(r, i, r.path, o)));
    return O.mergeArray(n, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new Z({
      ...this._def,
      minLength: { value: e, message: h.toString(r) }
    });
  }
  max(e, r) {
    return new Z({
      ...this._def,
      maxLength: { value: e, message: h.toString(r) }
    });
  }
  length(e, r) {
    return new Z({
      ...this._def,
      exactLength: { value: e, message: h.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Z.create = (t, e) => new Z({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: m.ZodArray,
  ...g(e)
});
function X(t) {
  if (t instanceof E) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = M.create(X(n));
    }
    return new E({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof Z ? new Z({
    ...t._def,
    type: X(t.element)
  }) : t instanceof M ? M.create(X(t.unwrap())) : t instanceof te ? te.create(X(t.unwrap())) : t instanceof B ? B.create(t.items.map((e) => X(e))) : t;
}
class E extends v {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = k.objectKeys(e);
    return this._cached = { shape: e, keys: r }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== f.object) {
      const l = this._getOrReturnCtx(e);
      return u(l, {
        code: c.invalid_type,
        expected: f.object,
        received: l.parsedType
      }), y;
    }
    const { status: n, ctx: s } = this._processInputParams(e), { shape: a, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof W && this._def.unknownKeys === "strip"))
      for (const l in s.data)
        i.includes(l) || o.push(l);
    const d = [];
    for (const l of i) {
      const p = a[l], x = s.data[l];
      d.push({
        key: { status: "valid", value: l },
        value: p._parse(new $(s, x, s.path, l)),
        alwaysSet: l in s.data
      });
    }
    if (this._def.catchall instanceof W) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const p of o)
          d.push({
            key: { status: "valid", value: p },
            value: { status: "valid", value: s.data[p] }
          });
      else if (l === "strict")
        o.length > 0 && (u(s, {
          code: c.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const p of o) {
        const x = s.data[p];
        d.push({
          key: { status: "valid", value: p },
          value: l._parse(
            new $(s, x, s.path, p)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: p in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const p of d) {
        const x = await p.key, K = await p.value;
        l.push({
          key: x,
          value: K,
          alwaysSet: p.alwaysSet
        });
      }
      return l;
    }).then((l) => O.mergeObjectSync(n, l)) : O.mergeObjectSync(n, d);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return h.errToObj, new E({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var a, i;
          const s = ((i = (a = this._def).errorMap) == null ? void 0 : i.call(a, r, n).message) ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: h.errToObj(e).message ?? s
          } : {
            message: s
          };
        }
      } : {}
    });
  }
  strip() {
    return new E({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new E({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new E({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new E({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: m.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new E({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    for (const n of k.objectKeys(e))
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new E({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    for (const n of k.objectKeys(this.shape))
      e[n] || (r[n] = this.shape[n]);
    return new E({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return X(this);
  }
  partial(e) {
    const r = {};
    for (const n of k.objectKeys(this.shape)) {
      const s = this.shape[n];
      e && !e[n] ? r[n] = s : r[n] = s.optional();
    }
    return new E({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    for (const n of k.objectKeys(this.shape))
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let a = this.shape[n];
        for (; a instanceof M; )
          a = a._def.innerType;
        r[n] = a;
      }
    return new E({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Zt(k.objectKeys(this.shape));
  }
}
E.create = (t, e) => new E({
  shape: () => t,
  unknownKeys: "strip",
  catchall: W.create(),
  typeName: m.ZodObject,
  ...g(e)
});
E.strictCreate = (t, e) => new E({
  shape: () => t,
  unknownKeys: "strict",
  catchall: W.create(),
  typeName: m.ZodObject,
  ...g(e)
});
E.lazycreate = (t, e) => new E({
  shape: t,
  unknownKeys: "strip",
  catchall: W.create(),
  typeName: m.ZodObject,
  ...g(e)
});
class _e extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function s(a) {
      for (const o of a)
        if (o.result.status === "valid")
          return o.result;
      for (const o of a)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = a.map((o) => new D(o.ctx.common.issues));
      return u(r, {
        code: c.invalid_union,
        unionErrors: i
      }), y;
    }
    if (r.common.async)
      return Promise.all(n.map(async (a) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(s);
    {
      let a;
      const i = [];
      for (const d of n) {
        const l = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, p = d._parseSync({
          data: r.data,
          path: r.path,
          parent: l
        });
        if (p.status === "valid")
          return p;
        p.status === "dirty" && !a && (a = { result: p, ctx: l }), l.common.issues.length && i.push(l.common.issues);
      }
      if (a)
        return r.common.issues.push(...a.ctx.common.issues), a.result;
      const o = i.map((d) => new D(d));
      return u(r, {
        code: c.invalid_union,
        unionErrors: o
      }), y;
    }
  }
  get options() {
    return this._def.options;
  }
}
_e.create = (t, e) => new _e({
  options: t,
  typeName: m.ZodUnion,
  ...g(e)
});
function De(t, e) {
  const r = U(t), n = U(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === f.object && n === f.object) {
    const s = k.objectKeys(e), a = k.objectKeys(t).filter((o) => s.indexOf(o) !== -1), i = { ...t, ...e };
    for (const o of a) {
      const d = De(t[o], e[o]);
      if (!d.valid)
        return { valid: !1 };
      i[o] = d.data;
    }
    return { valid: !0, data: i };
  } else if (r === f.array && n === f.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let a = 0; a < t.length; a++) {
      const i = t[a], o = e[a], d = De(i, o);
      if (!d.valid)
        return { valid: !1 };
      s.push(d.data);
    }
    return { valid: !0, data: s };
  } else return r === f.date && n === f.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class ve extends v {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), s = (a, i) => {
      if (tt(a) || tt(i))
        return y;
      const o = De(a.value, i.value);
      return o.valid ? ((rt(a) || rt(i)) && r.dirty(), { status: r.value, value: o.data }) : (u(n, {
        code: c.invalid_intersection_types
      }), y);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([a, i]) => s(a, i)) : s(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
ve.create = (t, e, r) => new ve({
  left: t,
  right: e,
  typeName: m.ZodIntersection,
  ...g(r)
});
class B extends v {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== f.array)
      return u(n, {
        code: c.invalid_type,
        expected: f.array,
        received: n.parsedType
      }), y;
    if (n.data.length < this._def.items.length)
      return u(n, {
        code: c.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), y;
    !this._def.rest && n.data.length > this._def.items.length && (u(n, {
      code: c.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const a = [...n.data].map((i, o) => {
      const d = this._def.items[o] || this._def.rest;
      return d ? d._parse(new $(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(a).then((i) => O.mergeArray(r, i)) : O.mergeArray(r, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new B({
      ...this._def,
      rest: e
    });
  }
}
B.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new B({
    items: t,
    typeName: m.ZodTuple,
    rest: null,
    ...g(e)
  });
};
class we extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== f.object)
      return u(n, {
        code: c.invalid_type,
        expected: f.object,
        received: n.parsedType
      }), y;
    const s = [], a = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      s.push({
        key: a._parse(new $(n, o, n.path, o)),
        value: i._parse(new $(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? O.mergeObjectAsync(r, s) : O.mergeObjectSync(r, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof v ? new we({
      keyType: e,
      valueType: r,
      typeName: m.ZodRecord,
      ...g(n)
    }) : new we({
      keyType: L.create(),
      valueType: e,
      typeName: m.ZodRecord,
      ...g(r)
    });
  }
}
class dt extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== f.map)
      return u(n, {
        code: c.invalid_type,
        expected: f.map,
        received: n.parsedType
      }), y;
    const s = this._def.keyType, a = this._def.valueType, i = [...n.data.entries()].map(([o, d], l) => ({
      key: s._parse(new $(n, o, n.path, [l, "key"])),
      value: a._parse(new $(n, d, n.path, [l, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const d of i) {
          const l = await d.key, p = await d.value;
          if (l.status === "aborted" || p.status === "aborted")
            return y;
          (l.status === "dirty" || p.status === "dirty") && r.dirty(), o.set(l.value, p.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const d of i) {
        const l = d.key, p = d.value;
        if (l.status === "aborted" || p.status === "aborted")
          return y;
        (l.status === "dirty" || p.status === "dirty") && r.dirty(), o.set(l.value, p.value);
      }
      return { status: r.value, value: o };
    }
  }
}
dt.create = (t, e, r) => new dt({
  valueType: e,
  keyType: t,
  typeName: m.ZodMap,
  ...g(r)
});
class ue extends v {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== f.set)
      return u(n, {
        code: c.invalid_type,
        expected: f.set,
        received: n.parsedType
      }), y;
    const s = this._def;
    s.minSize !== null && n.data.size < s.minSize.value && (u(n, {
      code: c.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), r.dirty()), s.maxSize !== null && n.data.size > s.maxSize.value && (u(n, {
      code: c.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), r.dirty());
    const a = this._def.valueType;
    function i(d) {
      const l = /* @__PURE__ */ new Set();
      for (const p of d) {
        if (p.status === "aborted")
          return y;
        p.status === "dirty" && r.dirty(), l.add(p.value);
      }
      return { status: r.value, value: l };
    }
    const o = [...n.data.values()].map((d, l) => a._parse(new $(n, d, n.path, l)));
    return n.common.async ? Promise.all(o).then((d) => i(d)) : i(o);
  }
  min(e, r) {
    return new ue({
      ...this._def,
      minSize: { value: e, message: h.toString(r) }
    });
  }
  max(e, r) {
    return new ue({
      ...this._def,
      maxSize: { value: e, message: h.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ue.create = (t, e) => new ue({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: m.ZodSet,
  ...g(e)
});
class ut extends v {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
ut.create = (t, e) => new ut({
  getter: t,
  typeName: m.ZodLazy,
  ...g(e)
});
class lt extends v {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return u(r, {
        received: r.data,
        code: c.invalid_literal,
        expected: this._def.value
      }), y;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
lt.create = (t, e) => new lt({
  value: t,
  typeName: m.ZodLiteral,
  ...g(e)
});
function Zt(t, e) {
  return new q({
    values: t,
    typeName: m.ZodEnum,
    ...g(e)
  });
}
class q extends v {
  constructor() {
    super(...arguments), ne.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return u(r, {
        expected: k.joinValues(n),
        received: r.parsedType,
        code: c.invalid_type
      }), y;
    }
    if (ye(this, ne, "f") || Ct(this, ne, new Set(this._def.values), "f"), !ye(this, ne, "f").has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return u(r, {
        received: r.data,
        code: c.invalid_enum_value,
        options: n
      }), y;
    }
    return I(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return q.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return q.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
ne = /* @__PURE__ */ new WeakMap();
q.create = Zt;
class ft extends v {
  constructor() {
    super(...arguments), se.set(this, void 0);
  }
  _parse(e) {
    const r = k.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== f.string && n.parsedType !== f.number) {
      const s = k.objectValues(r);
      return u(n, {
        expected: k.joinValues(s),
        received: n.parsedType,
        code: c.invalid_type
      }), y;
    }
    if (ye(this, se, "f") || Ct(this, se, new Set(k.getValidEnumValues(this._def.values)), "f"), !ye(this, se, "f").has(e.data)) {
      const s = k.objectValues(r);
      return u(n, {
        received: n.data,
        code: c.invalid_enum_value,
        options: s
      }), y;
    }
    return I(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
se = /* @__PURE__ */ new WeakMap();
ft.create = (t, e) => new ft({
  values: t,
  typeName: m.ZodNativeEnum,
  ...g(e)
});
class ke extends v {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== f.promise && r.common.async === !1)
      return u(r, {
        code: c.invalid_type,
        expected: f.promise,
        received: r.parsedType
      }), y;
    const n = r.parsedType === f.promise ? r.data : Promise.resolve(r.data);
    return I(n.then((s) => this._def.type.parseAsync(s, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
ke.create = (t, e) => new ke({
  type: t,
  typeName: m.ZodPromise,
  ...g(e)
});
class ee extends v {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === m.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), s = this._def.effect || null, a = {
      addIssue: (i) => {
        u(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), s.type === "preprocess") {
      const i = s.transform(n.data, a);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return y;
          const d = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return d.status === "aborted" ? y : d.status === "dirty" || r.value === "dirty" ? re(d.value) : d;
        });
      {
        if (r.value === "aborted")
          return y;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? y : o.status === "dirty" || r.value === "dirty" ? re(o.value) : o;
      }
    }
    if (s.type === "refinement") {
      const i = (o) => {
        const d = s.refinement(o, a);
        if (n.common.async)
          return Promise.resolve(d);
        if (d instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? y : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? y : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (s.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!Y(i))
          return i;
        const o = s.transform(i.value, a);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => Y(i) ? Promise.resolve(s.transform(i.value, a)).then((o) => ({
          status: r.value,
          value: o
        })) : i);
    k.assertNever(s);
  }
}
ee.create = (t, e, r) => new ee({
  schema: t,
  typeName: m.ZodEffects,
  effect: e,
  ...g(r)
});
ee.createWithPreprocess = (t, e, r) => new ee({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: m.ZodEffects,
  ...g(r)
});
class M extends v {
  _parse(e) {
    return this._getType(e) === f.undefined ? I(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
M.create = (t, e) => new M({
  innerType: t,
  typeName: m.ZodOptional,
  ...g(e)
});
class te extends v {
  _parse(e) {
    return this._getType(e) === f.null ? I(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
te.create = (t, e) => new te({
  innerType: t,
  typeName: m.ZodNullable,
  ...g(e)
});
class Ve extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === f.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Ve.create = (t, e) => new Ve({
  innerType: t,
  typeName: m.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...g(e)
});
class Ue extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return pe(s) ? s.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new D(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new D(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Ue.create = (t, e) => new Ue({
  innerType: t,
  typeName: m.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...g(e)
});
class ht extends v {
  _parse(e) {
    if (this._getType(e) !== f.nan) {
      const n = this._getOrReturnCtx(e);
      return u(n, {
        code: c.invalid_type,
        expected: f.nan,
        received: n.parsedType
      }), y;
    }
    return { status: "valid", value: e.data };
  }
}
ht.create = (t) => new ht({
  typeName: m.ZodNaN,
  ...g(t)
});
class On extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Fe extends v {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return a.status === "aborted" ? y : a.status === "dirty" ? (r.dirty(), re(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return s.status === "aborted" ? y : s.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new Fe({
      in: e,
      out: r,
      typeName: m.ZodPipeline
    });
  }
}
class ze extends v {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (s) => (Y(s) && (s.value = Object.freeze(s.value)), s);
    return pe(r) ? r.then((s) => n(s)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ze.create = (t, e) => new ze({
  innerType: t,
  typeName: m.ZodReadonly,
  ...g(e)
});
var m;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(m || (m = {}));
const z = L.create, xe = Q.create, mt = $e.create, An = Le.create;
W.create;
const Rn = Z.create, be = E.create;
_e.create;
ve.create;
B.create;
const Nn = we.create;
q.create;
ke.create;
M.create;
te.create;
be({
  version: xe(),
  lastUpdated: z().datetime(),
  namespaces: Nn(be({
    name: z(),
    version: xe(),
    createdAt: z().datetime(),
    updatedAt: z().datetime(),
    keys: Rn(z())
  }))
});
const Ee = be({
  schemaVersion: xe(),
  metadata: be({
    createdAt: z().datetime(),
    updatedAt: z().datetime(),
    namespace: z(),
    encrypted: mt().optional(),
    compressed: mt().optional(),
    ttl: xe().optional()
  }),
  data: An()
});
class R {
  constructor() {
    this.listeners = /* @__PURE__ */ new Map();
  }
  static new() {
    return R.instance || (R.instance = new R()), R.instance;
  }
  getFullKey(e, r) {
    return `${e}:${r}`;
  }
  notifyListeners(e, r, n) {
    const s = this.getFullKey(e, r);
    (this.listeners.get(s) || /* @__PURE__ */ new Set()).forEach((i) => i({ namespace: e, key: r, value: n }));
  }
  async set(e, r, n) {
    const s = Ee.parse(n);
    localStorage.setItem(this.getFullKey(e, r), _.stringify(s)), this.notifyListeners(e, r, s.data);
  }
  async getRaw(e, r) {
    const n = localStorage.getItem(this.getFullKey(e, r));
    if (!n) return;
    const s = _.parse(n);
    return Ee.parse(s);
  }
  async get(e, r) {
    const n = await this.getRaw(e, r);
    return n == null ? void 0 : n.data;
  }
  async has(e, r) {
    return localStorage.getItem(this.getFullKey(e, r)) !== null;
  }
  async delete(e, r) {
    const n = await this.has(e, r);
    return n && (localStorage.removeItem(this.getFullKey(e, r)), this.notifyListeners(e, r, void 0)), n;
  }
  async clear(e) {
    e ? Object.keys(localStorage).filter((n) => n.startsWith(`${e}:`)).forEach((n) => localStorage.removeItem(n)) : localStorage.clear(), this.listeners.clear();
  }
  async listNamespaces() {
    const e = /* @__PURE__ */ new Set();
    return Object.keys(localStorage).forEach((r) => {
      const [n] = r.split(":");
      e.add(n);
    }), Array.from(e);
  }
  async listKeys(e) {
    return Object.keys(localStorage).filter((r) => r.startsWith(`${e}:`)).map((r) => r.replace(`${e}:`, ""));
  }
  async watch(e, r) {
    const n = this.getFullKey(e, r);
    return {
      on: (s, a) => s !== "change" ? () => {
      } : (this.listeners.has(n) || this.listeners.set(n, /* @__PURE__ */ new Set()), this.listeners.get(n).add(a), () => {
        var i;
        return (i = this.listeners.get(n)) == null ? void 0 : i.delete(a);
      }),
      once: (s, a) => {
        if (s !== "change") return () => {
        };
        const i = (o) => {
          var d;
          a(o), (d = this.listeners.get(n)) == null || d.delete(i);
        };
        return this.listeners.has(n) || this.listeners.set(n, /* @__PURE__ */ new Set()), this.listeners.get(n).add(i), () => {
          var o;
          return (o = this.listeners.get(n)) == null ? void 0 : o.delete(i);
        };
      },
      off: (s, a) => {
        var i;
        s === "change" && ((i = this.listeners.get(n)) == null || i.delete(a));
      }
    };
  }
}
const In = {
  api: {
    id: "browser-store",
    capabilities: /* @__PURE__ */ new Set(["permanent", "structured", "watch", "namespace"]),
    // `init` and other methods in `web` don't `storePath`
    // but having a consistent API where first param of every method
    // is the path that filteres to the "realm" makes it easier to reason around
    async init(t) {
      try {
        return T(void 0);
      } catch (e) {
        return w({
          kind: "storage",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    async set(t, e, r, n, s) {
      try {
        const a = R.new(), i = await a.getRaw(e, r), o = (i == null ? void 0 : i.metadata.createdAt) || (/* @__PURE__ */ new Date()).toISOString(), d = (/* @__PURE__ */ new Date()).toISOString(), l = {
          schemaVersion: 1,
          metadata: {
            createdAt: o,
            updatedAt: d,
            namespace: e,
            encrypted: s == null ? void 0 : s.encrypt,
            compressed: s == null ? void 0 : s.compress,
            ttl: s == null ? void 0 : s.ttl
          },
          data: n
        };
        return await a.set(e, r, l), T(void 0);
      } catch (a) {
        return w({
          kind: "storage",
          message: a instanceof Error ? a.message : "Unknown error",
          cause: a
        });
      }
    },
    async get(t, e, r) {
      try {
        const n = R.new();
        return T(await n.get(e, r));
      } catch (n) {
        return w({
          kind: "storage",
          message: n instanceof Error ? n.message : "Unknown error",
          cause: n
        });
      }
    },
    async has(t, e, r) {
      try {
        const n = R.new();
        return T(await n.has(e, r));
      } catch (n) {
        return w({
          kind: "storage",
          message: n instanceof Error ? n.message : "Unknown error",
          cause: n
        });
      }
    },
    async remove(t, e, r) {
      try {
        const n = R.new();
        return T(await n.delete(e, r));
      } catch (n) {
        return w({
          kind: "storage",
          message: n instanceof Error ? n.message : "Unknown error",
          cause: n
        });
      }
    },
    async clear(t, e) {
      try {
        return await R.new().clear(e), T(void 0);
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async listNamespaces(t) {
      try {
        const e = R.new();
        return T(await e.listNamespaces());
      } catch (e) {
        return w({
          kind: "storage",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    async listKeys(t, e) {
      try {
        const r = R.new();
        return T(await r.listKeys(e));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async watch(t, e, r) {
      return R.new().watch(e, r);
    }
  }
}, Cn = {
  v1: In
};
class Te extends tr {
  constructor(e) {
    super(e);
  }
  /**
   * Create a new Store or load the existing store with the path.
   *
   * @example
   * ```typescript
   * import { Store } from '@tauri-apps/api/store';
   * const store = await Store.load('store.json');
   * ```
   *
   * @param path Path to save the store in `app_data_dir`
   * @param options Store configuration options
   */
  static async load(e, r) {
    const n = await b("plugin:store|load", {
      path: e,
      ...r
    });
    return new Te(n);
  }
  /**
   * Gets an already loaded store.
   *
   * If the store is not loaded, returns `null`. In this case you must {@link Store.load load} it.
   *
   * This function is more useful when you already know the store is loaded
   * and just need to access its instance. Prefer {@link Store.load} otherwise.
   *
   * @example
   * ```typescript
   * import { Store } from '@tauri-apps/api/store';
   * let store = await Store.get('store.json');
   * if (!store) {
   *   store = await Store.load('store.json');
   * }
   * ```
   *
   * @param path Path of the store.
   */
  static async get(e) {
    return await b("plugin:store|get_store", { path: e }).then((r) => r ? new Te(r) : null);
  }
  async set(e, r) {
    await b("plugin:store|set", {
      rid: this.rid,
      key: e,
      value: r
    });
  }
  async get(e) {
    const [r, n] = await b("plugin:store|get", {
      rid: this.rid,
      key: e
    });
    return n ? r : void 0;
  }
  async has(e) {
    return await b("plugin:store|has", {
      rid: this.rid,
      key: e
    });
  }
  async delete(e) {
    return await b("plugin:store|delete", {
      rid: this.rid,
      key: e
    });
  }
  async clear() {
    await b("plugin:store|clear", { rid: this.rid });
  }
  async reset() {
    await b("plugin:store|reset", { rid: this.rid });
  }
  async keys() {
    return await b("plugin:store|keys", { rid: this.rid });
  }
  async values() {
    return await b("plugin:store|values", { rid: this.rid });
  }
  async entries() {
    return await b("plugin:store|entries", { rid: this.rid });
  }
  async length() {
    return await b("plugin:store|length", { rid: this.rid });
  }
  async reload() {
    await b("plugin:store|reload", { rid: this.rid });
  }
  async save() {
    await b("plugin:store|save", { rid: this.rid });
  }
  async onKeyChange(e, r) {
    return await me("store://change", (n) => {
      n.payload.resourceId === this.rid && n.payload.key === e && r(n.payload.exists ? n.payload.value : void 0);
    });
  }
  async onChange(e) {
    return await me("store://change", (r) => {
      r.payload.resourceId === this.rid && e(r.payload.key, r.payload.exists ? r.payload.value : void 0);
    });
  }
}
const N = class N {
  constructor(e) {
    this.store = null, this.listeners = /* @__PURE__ */ new Map(), this.data = {}, this.storePath = e;
  }
  static new(e) {
    if (N.instances.has(e))
      return N.instances.get(e);
    const r = new N(e);
    return N.instances.set(e, r), r;
  }
  static async closeAll() {
    const e = Array.from(N.instances.values()).map((r) => r.close());
    await Promise.all(e), N.instances.clear();
  }
  static async closeStore(e) {
    const r = N.instances.get(e);
    r && (await r.close(), N.instances.delete(e));
  }
  async init() {
    if (!this.store) {
      this.store = await Te.load(this.storePath);
      const e = await this.store.get("data");
      this.data = e ?? {}, this.store.onChange((r, n) => {
        n && (this.data = n, this.notifyListeners());
      });
    }
  }
  notifyListeners() {
    var e;
    for (const [r, n] of this.listeners.entries()) {
      const [s, a] = r.split(":"), i = (e = this.data[s]) == null ? void 0 : e[a];
      n.forEach(
        (o) => o({
          namespace: s,
          key: a,
          value: i == null ? void 0 : i.data
        })
      );
    }
  }
  async set(e, r, n) {
    if (!this.store) throw new Error("Store not initialized");
    const s = Ee.parse(n);
    this.data[e] = this.data[e] || {}, this.data[e][r] = s, await this.store.set("data", this.data), await this.store.save();
  }
  async getRaw(e, r) {
    var a;
    const n = (a = this.data[e]) == null ? void 0 : a[r];
    return n ? Ee.parse(n) : void 0;
  }
  async get(e, r) {
    const n = await this.getRaw(e, r);
    return n == null ? void 0 : n.data;
  }
  async has(e, r) {
    var n;
    return !!((n = this.data[e]) != null && n[r]);
  }
  async delete(e, r) {
    var n;
    if (!this.store) throw new Error("Store not initialized");
    return (n = this.data[e]) != null && n[r] ? (delete this.data[e][r], Object.keys(this.data[e]).length === 0 && delete this.data[e], await this.store.set("data", this.data), await this.store.save(), !0) : !1;
  }
  async clear(e) {
    if (!this.store) throw new Error("Store not initialized");
    e ? delete this.data[e] : this.data = {}, await this.store.set("data", this.data), await this.store.save();
  }
  async listNamespaces() {
    return Object.keys(this.data);
  }
  async listKeys(e) {
    return Object.keys(this.data[e] || {});
  }
  async watch(e, r) {
    const n = `${e}:${r}`;
    return {
      on: (s, a) => s !== "change" ? () => {
      } : (this.listeners.has(n) || this.listeners.set(n, /* @__PURE__ */ new Set()), this.listeners.get(n).add(a), () => {
        var i;
        return (i = this.listeners.get(n)) == null ? void 0 : i.delete(a);
      }),
      once: (s, a) => {
        if (s !== "change") return () => {
        };
        const i = (o) => {
          var d;
          a(o), (d = this.listeners.get(n)) == null || d.delete(i);
        };
        return this.listeners.has(n) || this.listeners.set(n, /* @__PURE__ */ new Set()), this.listeners.get(n).add(i), () => {
          var o;
          return (o = this.listeners.get(n)) == null ? void 0 : o.delete(i);
        };
      },
      off: (s, a) => {
        var i;
        s === "change" && ((i = this.listeners.get(n)) == null || i.delete(a));
      }
    };
  }
  async close() {
    this.store && (await this.store.close(), this.store = null, this.data = {}, this.listeners.clear(), N.instances.delete(this.storePath));
  }
};
N.instances = /* @__PURE__ */ new Map();
let C = N;
const Pn = {
  api: {
    id: "tauri-store",
    capabilities: /* @__PURE__ */ new Set(["permanent", "structured", "watch", "namespace", "secure"]),
    async init(t) {
      try {
        return await C.new(t).init(), T(void 0);
      } catch (e) {
        return w({
          kind: "storage",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    async set(t, e, r, n, s) {
      try {
        const a = C.new(t), i = await a.getRaw(e, r), o = (i == null ? void 0 : i.metadata.createdAt) || (/* @__PURE__ */ new Date()).toISOString(), d = (/* @__PURE__ */ new Date()).toISOString(), l = {
          schemaVersion: 1,
          metadata: {
            createdAt: o,
            updatedAt: d,
            namespace: e,
            encrypted: s == null ? void 0 : s.encrypt,
            compressed: s == null ? void 0 : s.compress,
            ttl: s == null ? void 0 : s.ttl
          },
          data: n
        };
        return await a.set(e, r, l), T(void 0);
      } catch (a) {
        return w({
          kind: "storage",
          message: a instanceof Error ? a.message : "Unknown error",
          cause: a
        });
      }
    },
    async get(t, e, r) {
      try {
        const n = C.new(t);
        return T(await n.get(e, r));
      } catch (n) {
        return w({
          kind: "storage",
          message: n instanceof Error ? n.message : "Unknown error",
          cause: n
        });
      }
    },
    async has(t, e, r) {
      try {
        const n = C.new(t);
        return T(await n.has(e, r));
      } catch (n) {
        return w({
          kind: "storage",
          message: n instanceof Error ? n.message : "Unknown error",
          cause: n
        });
      }
    },
    async remove(t, e, r) {
      try {
        const n = C.new(t);
        return T(await n.delete(e, r));
      } catch (n) {
        return w({
          kind: "storage",
          message: n instanceof Error ? n.message : "Unknown error",
          cause: n
        });
      }
    },
    async clear(t, e) {
      try {
        return await C.new(t).clear(e), T(void 0);
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async listNamespaces(t) {
      try {
        const e = C.new(t);
        return T(await e.listNamespaces());
      } catch (e) {
        return w({
          kind: "storage",
          message: e instanceof Error ? e.message : "Unknown error",
          cause: e
        });
      }
    },
    async listKeys(t, e) {
      try {
        const r = C.new(t);
        return T(await r.listKeys(e));
      } catch (r) {
        return w({
          kind: "storage",
          message: r instanceof Error ? r.message : "Unknown error",
          cause: r
        });
      }
    },
    async watch(t, e, r) {
      return C.new(t).watch(e, r);
    }
  }
}, jn = {
  v1: Pn
};
function Vn() {
  return window.__KERNEL_MODE__ || "web";
}
function Un(t) {
  if (t === "desktop") {
    const e = {
      info: {
        name: "desktop-kernel",
        version: { major: 1, minor: 0, patch: 0 },
        capabilities: ["basic-io"]
      },
      io: ar.v1.api,
      relay: Tr.v1.api,
      store: jn.v1.api
    };
    return window.__KERNEL__ = e, e;
  } else {
    const e = {
      info: {
        name: "web-kernel",
        version: { major: 1, minor: 0, patch: 0 },
        capabilities: ["basic-io"]
      },
      io: Yt.v1.api,
      relay: kr.v1.api,
      store: Cn.v1.api
    };
    return window.__KERNEL__ = e, e;
  }
}
export {
  yt as MediaType,
  gt as body,
  H as content,
  Vn as getKernelMode,
  Un as initKernel,
  fr as relayRequestToNativeAdapter
};
